module.exports = __webpack_public_path__ + "img/grin.3bbdf34b.png";